module.exports = __webpack_public_path__ + "static/img/piece_2000.740bcb4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/piece/piece_2000.png
// module id = 7m0M
// module chunks = 0